export default function AboutSection() {
  return (
    <section id="about" className="py-24 px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-teal-50 text-teal-600 text-sm font-semibold rounded-full mb-4 tracking-wide uppercase">
            About GITS
          </span>
          <h2 className="font-['Playfair_Display'] text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Innovative Leadership in Conversational AI
          </h2>
          <div className="w-16 h-1 bg-teal-500 mx-auto rounded-full"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Text Content */}
          <div>
            <p className="text-gray-600 text-lg leading-relaxed mb-6">
              Peter Michael Gits is a seasoned technology executive and AI Innovation Leader with over 25 years of experience driving transformative change at the intersection of artificial intelligence, enterprise technology, and today's business strategy.
            </p>
            <p className="text-gray-600 text-lg leading-relaxed mb-6">
              As a <strong className="text-gray-900">Fractional Head of AI</strong>, Peter partners with forward-thinking companies to design and implement AI strategies that deliver measurable results. His unique blend of deep technical expertise and executive leadership enables him to bridge the gap between cutting-edge AI capabilities and real-world business needs focusing on what is possible now.
            </p>
            <p className="text-gray-600 text-lg leading-relaxed mb-10">
              With a proven track record at <strong className="text-gray-900">Cisco Systems</strong> — where he led teams of 75+ engineers, authored over 40+ issued patents, and helped generate over $2B in revenue — Peter brings Fortune 500-level AI expertise to businesses of all sizes.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6 mb-10">
              {[
                { value: '15+', label: 'Years Experience', icon: 'ri-time-line' },
                { value: '40+', label: 'Patents', icon: 'ri-lightbulb-line' },
                { value: '75+', label: 'Engineers Led', icon: 'ri-team-line' },
                { value: '$2B+', label: 'Revenue Generated', icon: 'ri-line-chart-line' },
              ].map((stat) => (
                <div key={stat.label} className="flex items-center gap-4 p-4 bg-gray-50 rounded-xl">
                  <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg">
                    <i className={`${stat.icon} text-teal-600 text-lg`}></i>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-gray-900">{stat.value}</div>
                    <div className="text-sm text-gray-500">{stat.label}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* Location Card */}
            <div className="flex items-center gap-3 p-4 bg-teal-50 rounded-xl border border-teal-100">
              <div className="w-10 h-10 flex items-center justify-center bg-teal-500 rounded-lg">
                <i className="ri-map-pin-line text-white text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-semibold text-gray-900">Based in Charlotte, NC</div>
                <div className="text-xs text-gray-500">509 Vermeer Court, Mount Holly, NC 28120</div>
              </div>
            </div>
          </div>

          {/* Right: Image + Map */}
          <div className="flex flex-col gap-6">
            <div className="rounded-2xl overflow-hidden shadow-xl h-72 lg:h-80">
              <img
                src="https://public.readdy.ai/ai/img_res/65bc88fe6c7cf016d257bb642aee2d22.jpg"
                alt="AI Technology"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-lg h-56">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3259.123456789!2d-81.0!3d35.3!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzXCsDE4JzAwLjAiTiA4McKwMDAnMDAuMCJX!5e0!3m2!1sen!2sus!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Peter Gits Location - Charlotte NC"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
